/* MancsLab – blogcikk kiegészítések (.ml-article)
   Behívva: sections/main-article.liquid
   Tartalomjegyzék, GYIK-harmonika, táblázat-keret, bevezető kártya és CTA-gomb.
   Csak a megjelenést alakítja, a cikk szövegét nem módosítja.
   The heading patterns recognise Hungarian, English and German articles; the table-of-contents label
   comes from the locale files (data-ml-toc-label, key mancslab.article.toc). */
(function () {
  var root = document.querySelector('.ml-article[itemprop="articleBody"]');
  if (!root || root.dataset.mlReady) return;
  root.dataset.mlReady = '1';

  function txt(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }
  function isHeading(el) { return el && /^H[1-6]$/.test(el.tagName); }
  function slug(s) {
    return s.toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'resz';
  }
  function emOnly(p) {
    return p && p.tagName === 'P' && p.children.length === 1 &&
      /^(EM|I)$/.test(p.children[0].tagName) && txt(p) === txt(p.children[0]);
  }

  var kids = Array.prototype.slice.call(root.children);

  // 1. "Utolsó frissítés" címke és jogi megjegyzés
  kids.forEach(function (el) {
    if (!emOnly(el)) return;
    if (/^(utols[óo] friss[íi]t[ée]s|last updated|zuletzt aktualisiert)/i.test(txt(el))) el.classList.add('ml-updated');
    else if (/^(fontos|important|wichtig)/i.test(txt(el))) el.classList.add('ml-disclaimer');
  });

  // 2. Bevezető kártya: az első érdemi bekezdés az első szakaszcím előtt
  //    (a régi cikkekben a cím-ismétlő h4 utáni első bekezdés)
  var sectionHeads = kids.filter(function (el) { return /^H[24]$/.test(el.tagName); });
  var leadDone = false;
  for (var i = 0; i < kids.length && !leadDone; i++) {
    var el = kids[i];
    if (sectionHeads.indexOf(el) > 0) break;
    if (el.tagName === 'P' && !el.className.replace(/\bMsoNormal\b/, '').trim() &&
        !el.querySelector('img') && txt(el).length > 90) {
      el.classList.add('ml-lead');
      leadDone = true;
    }
  }

  // 3. Táblázatok kerettel; telefonon a sorok címkézett kártyákká alakulnak
  Array.prototype.forEach.call(root.querySelectorAll('table'), function (t) {
    var p = t.parentElement;
    var w = p;
    if (!(p && p !== root && p.tagName === 'DIV' && p.children.length === 1)) {
      w = document.createElement('div');
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    }
    w.classList.add('ml-table');
    var headRow = t.tHead && t.tHead.rows[0];
    if (!headRow) return;
    var labels = Array.prototype.map.call(headRow.cells, function (c) { return txt(c); });
    if (labels.length < 2) return;
    Array.prototype.forEach.call(t.tBodies, function (tb) {
      Array.prototype.forEach.call(tb.rows, function (row) {
        Array.prototype.forEach.call(row.cells, function (c, i) {
          if (labels[i]) c.setAttribute('data-label', labels[i]);
        });
      });
    });
    w.classList.add('ml-table--stack');
  });

  // 4. Termék CTA: "→" jelű termék-/gyűjteménylink a bekezdés elején
  Array.prototype.forEach.call(root.querySelectorAll('p'), function (p) {
    var first = p.firstElementChild;
    if (!first || !/^(STRONG|B)$/.test(first.tagName)) return;
    var a = first.querySelector('a[href*="/products/"], a[href*="/collections/"]');
    if (!a || txt(a).indexOf('→') === -1) return;
    if (txt(p).indexOf(txt(first)) !== 0) return;
    p.classList.add('ml-cta');
  });

  // 5. GYIK harmonika
  var faqHead = kids.filter(function (el) {
    return /^H[24]$/.test(el.tagName) && /(gyakori k[ée]rd[ée]s|gyik|faq|frequently asked|h[äa]ufige fragen|h[äa]ufig gestellte fragen)/i.test(txt(el));
  })[0];
  if (faqHead) {
    var levelTag = faqHead.tagName;
    var qTag = levelTag === 'H2' ? 'H3' : 'H4';
    var items = [];
    var cur = null;
    var node = faqHead.nextElementSibling;
    while (node) {
      var next = node.nextElementSibling;
      if (node.tagName === 'H2' || node.tagName === 'SCRIPT') break;
      if (levelTag === 'H4' && node.tagName === 'H4' && !/[?”"]/.test(txt(node))) break;
      if (node.tagName === qTag) {
        cur = { q: node, a: [] };
        items.push(cur);
      } else if (cur && !isHeading(node) && !node.classList.contains('ml-disclaimer')) {
        cur.a.push(node);
      } else if (!cur) {
        // bevezető szöveg a kérdések előtt – marad a helyén
      } else {
        break;
      }
      node = next;
    }
    if (items.length >= 2) {
      var box = document.createElement('div');
      box.className = 'ml-faq';
      items[0].q.parentNode.insertBefore(box, items[0].q);
      items.forEach(function (it) {
        var d = document.createElement('details');
        var s = document.createElement('summary');
        s.textContent = txt(it.q).replace(/^[„“"]|[”“"]$/g, '');
        var body = document.createElement('div');
        body.className = 'ml-faq__a';
        it.a.forEach(function (n) { body.appendChild(n); });
        d.appendChild(s);
        d.appendChild(body);
        box.appendChild(d);
        it.q.parentNode.removeChild(it.q);
      });
    }
  }

  // 6. Források lista
  kids.forEach(function (el) {
    if (/^H[24]$/.test(el.tagName) && /^(forr[áa]sok|sources|quellen)/i.test(txt(el))) {
      var n = el.nextElementSibling;
      if (n && n.tagName === 'UL') n.classList.add('ml-sources');
    }
  });

  // 7. Tartalomjegyzék a szakaszcímekből
  var heads = Array.prototype.filter.call(root.querySelectorAll(':scope > h2, :scope > h4'), function (h) {
    return !/^(forr[áa]sok|sources|quellen)/i.test(txt(h));
  });
  var lead = root.querySelector('.ml-lead');
  var anchor = lead || heads[0];
  if (anchor) {
    heads = heads.filter(function (h) {
      return anchor.compareDocumentPosition(h) & Node.DOCUMENT_POSITION_FOLLOWING;
    });
  }
  if (heads.length >= 3 && anchor) {
    var used = {};
    var toc = document.createElement('details');
    toc.className = 'ml-toc';
    var sum = document.createElement('summary');
    sum.textContent = root.dataset.mlTocLabel || 'Ebben a cikkben';
    var ol = document.createElement('ol');
    heads.forEach(function (h) {
      var id = h.id || slug(txt(h));
      while (used[id] || (!h.id && document.getElementById(id))) id += '-2';
      used[id] = 1;
      h.id = id;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = txt(h).replace(/^\d+\.\s*/, '').replace(/[:.]$/, '');
      li.appendChild(a);
      ol.appendChild(li);
    });
    toc.appendChild(sum);
    toc.appendChild(ol);
    if (window.matchMedia('(min-width: 750px)').matches) toc.open = true;
    heads[0].parentNode.insertBefore(toc, heads[0]);
  }
})();